var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apply-form-settings',{attrs:{"form-setting":_vm.applyForm,"preloader":_vm.loader || _vm.preloader},on:{"update":_vm.updateSetting,"viewForm":_vm.viewForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }